module.exports = function() {
  return new Worker(__webpack_public_path__ + "f536df17d2b314a6a211.worker.js");
};